
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import WTPWorkMasterPagePopup from '../../WTPMasterPageData/WTPWorkMaster/WTPWorkMasterPagePopup'
import WTPWaterQualityDataUploadPagePopupFirst from './WTPWaterQualityDataUploadPagePopupFirst'
import WTPWaterQualityDataUploadPagePopupSecond from './WTPWaterQualityDataUploadPagePopupSecond'
import { ParameterDDL } from '../../../../../../Components/CommonDDL/ParameterDDL'
import moment from 'moment'
import { WTPWardNameDDL } from '../../../../../../Components/CommonDDL/NewWTPWardNameDDL'
import { WTPWaterQualityDeleteAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/DataUploadSlice/DataUploadSlice'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WTPWaterQtyDataTableDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/DataUploadSlice/DataUploadSlice'
import { Loading } from '../../../../../../Helper/Loading'
import { WTPWaterQualityDataUploadPageExcelExport } from './WTPWaterQualityDataUploadPageExcelExport'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'


export default function WTPWaterQualityDataUploadPage() {

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()


    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPWaterQualityDataUploadPagePopupFirstShow, setWTPWaterQualityDataUploadPagePopupFirstShow] = useState(0)
    const [WTPWaterQualityDataUploadPagePopupSecondShow, setWTPWaterQualityDataUploadPagePopupSecondShow] = useState(0)

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [isSearch, setIsSearch] = useState(false)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(99999)
    const [IsPost, setIsPost] = useState(false)
    const [ExportData, setExportData] = useState([])
    const [isExportLoading, setisExportLoading] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WTPWardNameDDLID, setWTPWardNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [ParameterID, setParameterID] = useState({
        DDL: [],
        ID: localStorage.getItem('ParameterID') ? localStorage.getItem('ParameterID') : 0,
        Label: localStorage.getItem('FinancialIDLabel') ? localStorage.getItem('FinancialIDLabel') : 'Select...',
    })

    // const date = Month?.ID != 0 && moment().month(Month?.ID - 1).format('YYYY-MM-DD');
    // const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).format('YYYY-MM-DD'));
    // const [ReadingData, setReadingData] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWTPWaterQualityDataUploadPagePopupFirstShow(true)
    }

    const handleEditOnClick = (item) => {
        setWTPWaterQualityDataUploadPagePopupFirstShow(true)
        setapiFlag('Update')
        setrowData()
    }

    const handleOnCloseClick = () => {
        setWTPWaterQualityDataUploadPagePopupFirstShow(false)
    }

    const handleOnCloseClickSecond = () => {
        setWTPWaterQualityDataUploadPagePopupSecondShow(false)
    }

    const handleIsSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    useEffect(() => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
    }, [ParameterID.ID, WTPWardNameDDLID.ID])

    useEffect(() => {
        setTimeout(() => {
            GetTableData()
        }, 500);
    }, [IsPost, ParameterID.ID, WardName.ID, To, FromDate, ToDate])

    const GetTableData = (value) => {
        const data = {
            // ReadingDate: ReadingData ? moment(ReadingData).format('YYYY-MM-DD') : '',
            FromDate: FromDate,
            ToDate: ToDate,
            WaterQtyM_IndicatorID: ParameterID.ID,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleGetExport: handleGetExport
        }
        dispatch(WTPWaterQtyDataTableDataAPI({ data }))
    }
    const { isLoading, tableData } = useSelector(state => state.WTPWaterQtyDataTableData)

    const handleGetExport = () => {
        setisExportLoading(true)
        const data = {
            // ReadingDate: ReadingData ? moment(ReadingData).format('YYYY-MM-DD') : '',
            FromDate: FromDate,
            ToDate: ToDate,
            WaterQtyM_IndicatorID: ParameterID.ID,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: "1",
            To: "99999",
            handleGetExport: handleSetExportData
        }
        dispatch(WTPWaterQtyDataTableDataAPI({ data }))
    }

    const handleSetExportData = (data) => {
        setisExportLoading(false)
        setExportData(data)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        // setReadingData(date ? date : moment().format('YYYY-MM-DD'))
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))

        setWTPWardNameDDLID({
            ...WTPWardNameDDLID,
            ID: 0,
            Label: 'Select...',
        })
        setParameterID({
            ...ParameterID,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_WaterQualityID: item?.t_wtP_WaterQualityID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(WTPWaterQualityDeleteAPI({ data }))
    }

    return (
        <div>
            {isLoading && <Loading />}

            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />

            <div className="wrapper">

                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />

                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Water Quality</h5>
                                <div className="float-end butt">
                                    {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.length > 0 &&
                                            <WTPWaterQualityDataUploadPageExcelExport
                                                ExcelData={ExportData}
                                                name='Water Quality'
                                                // FromDate={ReadingData}
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                                ParameterID={ParameterID}
                                            />
                                    }

                                    <i className="fa-solid fa-plus float-end btn btn-secondary mr-1"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">
                                            {/* <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>Date </b></label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={ReadingData}
                                                        onChange={(e) => (setReadingData(e.target.value))}
                                                    />
                                                </div>
                                            </div> */}

                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />
                                                </div>
                                            </div>


                                            <div className="col-lg-3 col-md-6">
                                                {/* <label for=""><b>Ward Name</b></label> */}
                                                {/* <WTPWardNameDDL
                                                    WTPWardNameDDLID={WTPWardNameDDLID}
                                                    setWTPWardNameDDLID={setWTPWardNameDDLID}
                                                    Flag="WaterQuality"
                                                /> */}
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                />
                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Parameter </b></label>
                                                <ParameterDDL
                                                    ParameterID={ParameterID}
                                                    setParameterID={setParameterID}
                                                    Flag="Master"
                                                />

                                            </div>
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleIsSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-2">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Parameter</th>
                                                        <th>Time</th>
                                                        {
                                                            (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) &&
                                                            <>
                                                                <th>Raw Water</th>
                                                                <th>Settled Water</th>
                                                                <th>Filtered Water</th>
                                                                <th>Pure Water</th>
                                                            </>
                                                        }

                                                        {
                                                            ParameterID.ID == 32 &&
                                                            <th>Lit/Hrs</th>
                                                        }

                                                        {
                                                            ParameterID.ID == 33 &&
                                                            <>
                                                                <th>Lit/Hrs</th>
                                                                <th>PPM</th>
                                                            </>
                                                        }

                                                        {
                                                            (ParameterID.ID == 34 || ParameterID.ID == 35) &&
                                                            <>
                                                                <th>Kg/Hrs</th>
                                                                <th>PPM</th>
                                                            </>
                                                        }
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        tableData && tableData.length > 0 ? tableData.map((j, i) => {
                                                            return (
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{j?.rowNum}</td>
                                                                    <td>{j?.readingDate ? moment(j?.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                    <td>{j?.waterQuality_IndicatorName}</td>
                                                                    <td style={{ textAlign: 'right' }}>{j?.timeValue}</td>
                                                                    {
                                                                        (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) &&
                                                                        <>
                                                                            <td style={{ textAlign: 'right' }}>{j?.rawWater}</td>
                                                                            <td style={{ textAlign: 'right' }}>{j?.settledWater}</td>
                                                                            <td style={{ textAlign: 'right' }}>{j?.filteredWater}</td>
                                                                            <td style={{ textAlign: 'right' }}>{j?.pureWater}</td>
                                                                        </>
                                                                    }

                                                                    {
                                                                        ParameterID.ID == 32 &&
                                                                        <td>{j?.literHours}</td>
                                                                    }

                                                                    {
                                                                        ParameterID.ID == 33 &&
                                                                        <>
                                                                            <td>{j?.literHours}</td>
                                                                            <td>{j?.ppm}</td>
                                                                        </>
                                                                    }

                                                                    {
                                                                        (ParameterID.ID == 34 || ParameterID.ID == 35) &&
                                                                        <>
                                                                            <td>{j?.kgHours}</td>
                                                                            <td>{j?.ppm}</td>
                                                                        </>
                                                                    }

                                                                    <td style={{ textAlign: "center" }}>
                                                                        {/* <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick()}
                                                                            >
                                                                            </i>
                                                                        </span> */}
                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                item={j}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                            :
                                                            <td colSpan={10}>No Data Found ...</td>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {/* {tableData && tableData.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        } */}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPWaterQualityDataUploadPagePopupFirstShow ?
                        <WTPWaterQualityDataUploadPagePopupFirst
                            open={WTPWaterQualityDataUploadPagePopupFirstShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            IsPost={IsPost}
                            setIsPost={setIsPost}
                        // rowData={rowData}
                        />
                        : <></>
                }
                {
                    WTPWaterQualityDataUploadPagePopupSecondShow ?
                        <WTPWaterQualityDataUploadPagePopupSecond
                            open={WTPWaterQualityDataUploadPagePopupSecondShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClickSecond={handleOnCloseClickSecond}
                            Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}



// API Response (04-02-2025) LIVE http://newapi.nmmcsmartservices.com
// {
//     "code": 200,
//     "message": "Successful",
//     "url": null,
//     "status": true,
//     "data": {
//       "table": [
//         {
//           "m_IndicatorID": 28,
//           "indicatorName": "Temperature (°C)"
//         },
//         {
//           "m_IndicatorID": 29,
//           "indicatorName": "Turbidity (N.T.U.)"
//         },
//         {
//           "m_IndicatorID": 30,
//           "indicatorName": "P.H. Value"
//         },
//         {
//           "m_IndicatorID": 31,
//           "indicatorName": "Residual Chlorine ( PPM)"
//         },
//         {
//           "m_IndicatorID": 32,
//           "indicatorName": "Rate Of Raw Water"
//         },
//         {
//           "m_IndicatorID": 33,
//           "indicatorName": "Coagulant Aid"
//         },
//         {
//           "m_IndicatorID": 34,
//           "indicatorName": "Pre Chlorination"
//         },
//         {
//           "m_IndicatorID": 35,
//           "indicatorName": "Post Chlorination"
//         }
//       ]
//     }
//   }